import { useEffect } from "react";
import useLocalStorage from "./useLocalStorage.js";

function useSettingsState(key, initialValue) {
  const [value, setValue] = useLocalStorage(key, initialValue);

  useEffect(() => {
    document.body.dataset[key] = value;
  }, [value, key]);

  return [value, setValue];
}

export default useSettingsState;
